<template>
  <div>
    <NavButton chevron :toggled="showMenu" class="hidden md:flex" @click="toggleMenu">
      {{ $t('header.our_services') }}
    </NavButton>
    <NavMenu :show="showMenu" :showing-all-services="showAllServices" @hide="toggleMenu(false)">
      <div class="md:hidden border-t-2 pt-ds-sm mb-ds-xxs mt-ds-sm text-black opacity-50 w-full">
        {{ $t('header.services') }}
      </div>
      <NavMenuItem
        image="nav_removals"
        :url="getUrlByHostVersion('nav_removals')"
        qa-tag="nav-our-services-removals"
        @click="$emit('track', 'our-services', 'removals')"
      >
        Déménagement
      </NavMenuItem>
      <NavMenuItem
        v-if="frFlagVersion==='v4'"
        image="nav_removals_paris"
        :url="getUrlByHostVersion('nav_removals_paris')"
        qa-tag="nav-our-services-removals-paris"
        @click="$emit('track', 'our-services', 'removals-paris')"
      >
        Déménagement Paris
      </NavMenuItem>
      <NavMenuItem
        image="nav_international"
        :url="getUrlByHostVersion('nav_international')"
        qa-tag="nav-our-services-international"
        @click="$emit('track', 'our-services', 'international')"
      >
        Déménagement Europe
      </NavMenuItem>
      <NavMenuItem
        image="nav_furniture"
        :url="getUrlByHostVersion('nav_furniture')"
        qa-tag="nav-our-services-furniture"
        @click="$emit('track', 'our-services', 'furniture')"
      >
        Transport meubles
      </NavMenuItem>
      <NavMenuItem
        v-if="frFlagVersion==='v4'"
        image="nav_van"
        :url="getUrlByHostVersion('nav_van')"
        qa-tag="nav-our-services-van"
        @click="$emit('track', 'our-services', 'man-and-van')"
      >
        Petit déménagement
      </NavMenuItem>
      <NavMenuItem
        image="nav_car"
        :url="getUrlByHostVersion('nav_car')"
        qa-tag="nav-our-services-car"
        @click="$emit('track', 'our-services', 'car')"
      >
        Transport voiture
      </NavMenuItem>
      <NavMenuItem
        image="nav_motorcycle"
        :url="getUrlByHostVersion('nav_motorcycle')"
        qa-tag="nav-our-services-motorcycle"
        @click="$emit('track', 'our-services', 'motorcycle')"
      >
        Transport motos
      </NavMenuItem>
      <NavMenuItem
        image="nav_piano"
        :url="getUrlByHostVersion('nav_piano')"
        qa-tag="nav-our-services-piano"
        @click="$emit('track', 'our-services', 'piano')"
      >
        Transport pianos
      </NavMenuItem>
      <NavMenuItem
        image="nav_ebay"
        :url="getUrlByHostVersion('nav_ebay')"
        qa-tag="nav-our-services-ebay"
        @click="$emit('track', 'our-services', 'ebay')"
      >
        Livraison eBay
      </NavMenuItem>
      <!-- mobile-only -->
      <NavLoginButton
        services
        redirect-url="https://www.anyvan.fr/connexion"
        qa-tag="nav-our-services-login"
        class="mt-auto"
      />
      <!-- end mobile-only -->
    </NavMenu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import NavOurServicesBase from "~/components/base/navOurServices"
import { frConfig } from "~/services/public/FrConfig"

export default defineComponent({
  name: "NavOurServicesFr",
  extends: NavOurServicesBase,
  data() {
    return {
      frFlagVersion: 'v2' as 'v2' | 'v4'
    }
  },
  methods: {
    getUrlByHostVersion(urlName: keyof typeof frConfig.v2): string {
      const url = frConfig[this.frFlagVersion][urlName]
      if (url.includes("/fr/")) {
        return url
      } else {
        return this.v4Host + url
      }
    }
  },
  mounted() {
    if (window?.av?.context?.featureFlags?.fr_prelisting_routing_destination === 'v4') {
      this.frFlagVersion = 'v4'
    }
  }
})
</script>
